/**
 * @file コンポーネント：ログインモーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useRef, useState } from "react";

// 関数読み込み
import { fnGetParameter } from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalLogin = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * ログインボタンクリック時の処理
     */
    const refInputEmail = useRef(null); // メールアドレス
    const refInputPassword = useRef(null); // パスワード
    const refInputKeepLogin = useRef(null); // ログイン情報を記憶
    const fnClickLogin = (e) => {
        props.setLoginErrorMessages([]);
        e.preventDefault();
        const password = window.btoa(refInputPassword.current.value);
        props.setEmail(refInputEmail.current.value);
        props.setPassword(password);
        const api = "/api/login";
        const token = document
            .getElementById("requestverificationtoken")
            .getAttribute("value");
        const options = {
            body: JSON.stringify({
                email: refInputEmail.current.value,
                password,
                rememberMe: refInputKeepLogin.current.checked,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: token,
            },
            method: "POST",
        };
        fetch(api, options)
            .then((response) => {
                // エラーページにリダイレクトされた場合
                if (response.url.indexOf("Error") !== -1) {
                    throw new Error("An error has occurred.");
                }
                // ステータスコードが200番台以外かつ400番以外の場合
                if (!response.ok && response.status !== 400) {
                    throw new Error(String(response.status));
                }
                // エラーではない場合
                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                if (result.StatusCode === 200) {
                    if (result.UserType === 5 && !fnGetParameter("refPage")) {
                        // 執刀医権限ユーザーかつrefPageパラメーターがない場合
                        location.href = "/admin";
                    } else {
                        location.href = props.redirectUrl;
                    }
                } else if (result.StatusCode === 400 && result.ResetPassword) {
                    props.setIsOpenModalLogin(false);
                    props.setIsOpenModalNewPassword(true);
                } else if (result.StatusCode === 400) {
                    const messages = [];
                    for (const error of result.Errors) {
                        messages.push(error.Message);
                    }
                    props.setLoginErrorMessages(messages);
                }
            })
            .catch((error) => {
                console.error(error);
                props.setLoginErrorMessages([
                    localized["ErrorMessage.LoginError"],
                ]);
            });
    };
    const fnPressEnter = (e) => {
        if (e.key === "Enter") {
            fnClickLogin(e);
        }
    };

    /**
     * パスワード
     */
    // 目アイコンクリックで表示非表示
    const [isShowPassword, setIsShowPassword] = useState(false);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnClickLogin={fnClickLogin}
            fnPressEnter={fnPressEnter}
            refInputEmail={refInputEmail}
            refInputPassword={refInputPassword}
            refInputKeepLogin={refInputKeepLogin}
            parameteRefPage={fnGetParameter("refPage")}
            isShowPassword={isShowPassword}
            setIsShowPassword={setIsShowPassword}
        />
    );
};
